import attemptMessageReducer from './custom/assignment-attempt-mutations/reducer';
import classroomsReducer from './custom/classrooms/reducer';
import resourceFavoritesReducer from './custom/resource-favorites-mutations/reducer';
import lessonPlanMutationReducer from './custom/lesson-plan-mutations/reducer';
import { EntityAction } from './types';

const reducerMap = {
  ASSIGNMENT_ATTEMPT: attemptMessageReducer,
  CLASSROOMS: classroomsReducer,
  RESOURCE_FAVORITE: resourceFavoritesReducer,
  LESSON_PLAN_MUTATION: lessonPlanMutationReducer
};

const customEntityStoreReducer = (state, action) => {
  const [namespace] = action.type.split('.');
  const reducer = reducerMap[namespace];

  return reducer(state, action);
};

const resolveCustomEntityStoreReducer = (state, action: EntityAction) => {
  return {
    ...customEntityStoreReducer(state, { ...action, type: action.requestActionType })
  };
};

export default resolveCustomEntityStoreReducer;
